module.exports = __webpack_public_path__ + "img/man_thumbnail.ea47c446.png";